import React from 'react';
import { cx } from '@/ui/utils/cx';

export type AppInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  inputSize?: 'sm' | 'md' | 'lg';
  hasError?: boolean;
};

const AppInput = React.forwardRef<HTMLInputElement, AppInputProps>(function AppInput(
  { className, inputSize = 'md', hasError = false, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cx(
        'app-control',
        inputSize !== 'md' && `app-control--${inputSize}`,
        hasError && 'app-control--error',
        className,
      )}
      {...rest}
    />
  );
});

export default AppInput;
